import { FC, useEffect, useMemo } from 'react';
import { MultiSelect } from '../../../../../../../../../features/multi-select/multi-select';
import { NestedIdValue } from '../../../../../../../../../features/multi-select/use-multi-select';
import { getValueFromOptions } from '../../../../../../../../../helpers/mappers';
import { useLang } from '../../../../../../../../../hooks/use-lang';
import { useDishMenuStore } from '../../../../../../../../../store/use-dish-menu-store';
import { IdValue } from '../../../../../../../../../types/props';
import { ChartFilters } from '../../../use-dashboard-charts';
import s from './dasboard-charts-widget-tasks-filters.module.css';

export const DashboardChartsWidgetTasksFilters: FC<ChartFilters> = ({ categories, sections }) => {
  const { getLocale } = useLang();
  const { menuListSections, fetchMenuListSections, menuList } = useDishMenuStore();

  useEffect(() => {
    fetchMenuListSections({ since_id: 0, n: 1000, customCache: true, is_by_company: true });
  }, []);

  const groupedSections: NestedIdValue[] = useMemo(() => {
    const result: NestedIdValue[] = [];
    Object.entries(menuListSections || {}).forEach(([key, value]) => {
      const menuName = getLocale(menuList?.find((menu) => menu.id === key)?.name);
      const menuSections = value.map((section) => ({
        id: String(section.id),
        value: getLocale(section.name),
      }));
      result.push({ id: key, value: menuName, children: menuSections });
    });
    return result;
  }, [menuListSections, menuList]);

  const allSections = useMemo(() => {
    const result: IdValue[] = [];
    Object.values(menuListSections || {}).forEach((value) => {
      value.forEach((section) => {
        result.push({ id: String(section.id), value: getLocale(section.name) });
      });
    });
    return result;
  }, [menuListSections]);

  const groupedCategories: NestedIdValue[] = useMemo(() => {
    const result: NestedIdValue[] = [];
    Object.values(menuListSections || {}).forEach((value) => {
      value.forEach((section) => {
        section.categories?.forEach((category) => {
          result.push({ id: String(category.id), value: getLocale(category.name) });
        });
      });
    });
    return result;
  }, [menuListSections]);

  const allCategories = useMemo(() => {
    const result: IdValue[] = [];
    Object.values(menuListSections || {}).forEach((value) => {
      value.forEach((section) => {
        section.categories?.forEach((category) => {
          result.push({ id: String(category.id), value: getLocale(category.name) });
        });
      });
    });
    return result;
  }, [allSections]);

  const selectedSections = getValueFromOptions(allSections, sections?.sectionIds);
  const selectedCategories = getValueFromOptions(allCategories, categories?.categoryIds);

  return (
    <div className={s.feature}>
      {sections && (
        <MultiSelect
          options={groupedSections}
          onSelect={(e) => sections.onChangeSectionIds(e.map((item) => item.id))}
          value={selectedSections}
        />
      )}
      {categories && (
        <MultiSelect
          options={groupedCategories}
          onSelect={(e) => categories.onChangeCategoryIds(e.map((item) => item.id))}
          value={selectedCategories}
        />
      )}
    </div>
  );
};
